<div *ngFor="let subField of field?.fieldGroup">
    <formly-field [field]="subField"></formly-field>
    <span class="explainer-style">{{subField.props.cronExplainer}}</span>
</div>
<ng-container *ngIf="field?.props?.showGenerateExpressionFields">
    <div class="cron-container">
        <app-common-sidebar [dynamicContent]="template1"></app-common-sidebar>
    </div>
</ng-container>

<ng-template #template1>
    <div class="cron-header">
        <div class="cron-heading-container">
            <div class="cron-icons">
                <div [innerHTML]="generatorIcon | safeHtml"></div>
                <div class="close-icon-style" [innerHTML]="closeIcon | safeHtml"
                    (click)="field.props.showGenerateExpressionFields = false"></div>
            </div>
            <div class="d-flex cron-heading">
                <div class="heading-style">
                    <span>
                        Generate Cron Expressions
                    </span>
                </div>
                <div class="sub-heading-style">
                    <span>
                        This calculator helps you to build cron expressions
                    </span>
                </div>
            </div>
        </div>
        <div class="d-flex">
            <span class="cron-generator-style d-flex">
                Cron generator:
            </span>
        </div>
    </div>
    <app-cron-plugin [cronFlavor]="field?.props?.cronFlavor"></app-cron-plugin>
</ng-template>